import React, { Fragment } from 'react';
import { MessageBar } from '@zapier/common-components';
import { Link, Spacer } from '@zapier/design-system';
import { formatDateTime } from '@zapier/date';
import { PendingInvoice } from '@zapier/design-system-revenue/src/types';

export const PendingPaymentWarningBar = (props: {
  pendingInvoice: PendingInvoice;
}) => {
  return (
    <Fragment>
      <MessageBar
        borderRadius="large"
        hideIcon={true}
        title="Hi there!"
        type="warning"
      >
        Your{' '}
        <strong>
          {formatDateTime(props.pendingInvoice.createdAt, 'default')}
        </strong>{' '}
        <Link href="/help/account/billing-pricing/why-my-payment-pending-and-why-cant-i-change-my-plan">
          payment is still pending
        </Link>
        . Please check back later to make plan changes.
      </MessageBar>
      <Spacer height={10} />
    </Fragment>
  );
};
